// dashboard/Parametres.jsx
import React, { useState } from 'react';
import { Save } from 'lucide-react';
import './Parametres.css';

const Parametres = () => {
    const [settings, setSettings] = useState({
        delaiParution: '7',
        prixAnnonce: '15000',
        emailNotifications: 'admin@fratmat.ci',
        validationAutomatique: true,
        notificationNouvellesAnnonces: true,
        notificationPaiements: true
    });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSettings(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            // Simulation d'un appel API
            await new Promise(resolve => setTimeout(resolve, 1000));

            setMessage('Paramètres enregistrés avec succès !');
            setTimeout(() => setMessage(''), 3000);
        } catch (error) {
            setMessage('Erreur lors de l\'enregistrement des paramètres');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="parametres-container">
            <div className="parametres-header">
                <h2>Paramètres</h2>
                <p>Configurez les paramètres de publication et de notification</p>
            </div>

            {message && (
                <div className={`message ${message.includes('Erreur') ? 'message-error' : 'message-success'}`}>
                    {message}
                </div>
            )}

            <form onSubmit={handleSubmit} className="parametres-form">
                {/* Paramètres de publication */}
                <div className="settings-section">
                    <h3>Paramètres de publication</h3>

                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="delaiParution">Délai de parution (jours)</label>
                            <input
                                type="number"
                                id="delaiParution"
                                name="delaiParution"
                                value={settings.delaiParution}
                                onChange={handleChange}
                                min="1"
                                max="30"
                                className="form-input"
                            />
                            <span className="form-hint">Délai en jours avant publication des annonces</span>
                        </div>

                        <div className="form-group">
                            <label htmlFor="prixAnnonce">Prix d'une annonce (FCFA)</label>
                            <input
                                type="number"
                                id="prixAnnonce"
                                name="prixAnnonce"
                                value={settings.prixAnnonce}
                                onChange={handleChange}
                                min="1000"
                                step="1000"
                                className="form-input"
                            />
                            <span className="form-hint">Montant en FCFA pour une annonce</span>
                        </div>
                    </div>

                    <div className="form-group">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="validationAutomatique"
                                checked={settings.validationAutomatique}
                                onChange={handleChange}
                                className="checkbox-input"
                            />
                            <span className="checkbox-text">Validation automatique</span>
                        </label>
                        <span className="form-hint">Les annonces seront automatiquement validées après paiement</span>
                    </div>
                </div>

                {/* Notifications */}
                <div className="settings-section">
                    <h3>Notifications</h3>

                    <div className="form-group">
                        <label htmlFor="emailNotifications">Email pour les notifications</label>
                        <input
                            type="email"
                            id="emailNotifications"
                            name="emailNotifications"
                            value={settings.emailNotifications}
                            onChange={handleChange}
                            className="form-input"
                            required
                        />
                        <span className="form-hint">Adresse email pour recevoir les notifications système</span>
                    </div>

                    <div className="notification-toggles">
                        <div className="form-group">
                            <label className="toggle-label">
                                <span>Notification pour nouvelles annonces</span>
                                <div className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        name="notificationNouvellesAnnonces"
                                        checked={settings.notificationNouvellesAnnonces}
                                        onChange={handleChange}
                                        className="toggle-input"
                                    />
                                    <span className="toggle-slider"></span>
                                </div>
                            </label>
                        </div>

                        <div className="form-group">
                            <label className="toggle-label">
                                <span>Notification pour paiements</span>
                                <div className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        name="notificationPaiements"
                                        checked={settings.notificationPaiements}
                                        onChange={handleChange}
                                        className="toggle-input"
                                    />
                                    <span className="toggle-slider"></span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                {/* Bouton de sauvegarde */}
                <div className="form-actions">
                    <button
                        type="submit"
                        className="save-button"
                        disabled={loading}
                    >
                        <Save size={20} />
                        {loading ? 'Enregistrement...' : 'Enregistrer les modifications'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Parametres;